module.exports = __webpack_public_path__ + "static/media/logo.0d9ab1de.png";